smoothly-app {
	--header-height: 5rem;
	display: block;
}

smoothly-app>smoothly-notifier>main {
	height: calc(100dvh - var(--header-height));
}

smoothly-app[hidden] {
	display: none;
}

smoothly-app>smoothly-notifier {
	height: 100%;
	background: none;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header:has(smoothly-burger)>nav>ul smoothly-app-room {
	width: 100%;
	height: 4em;
}

smoothly-app>smoothly-notifier>header {
	position: sticky;
	top: 0;
	z-index: 20;
	width: 100%;
	height: var(--header-height);
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
	align-items: center;
	box-shadow: 0 1px 0 0 rgb(var(--smoothly-color-shade)) inset;
}

smoothly-app>smoothly-notifier>header>nav {
	width: 100%;
	flex-shrink: 2;
	height: 100%;
}

smoothly-app>smoothly-notifier>header>nav,
smoothly-app>smoothly-notifier>header>nav>ul {
	display: flex;
	margin: 0;
}

smoothly-app:not([label])>smoothly-notifier>header>h1 {
	display: none;
}
smoothly-app>smoothly-notifier>header>h1 {
	margin-left: 1rem;
	margin-bottom: 0.8em;
	display: flex;
	height: 100%;
}

smoothly-app>smoothly-notifier>header>h1>a {
	display: inline-block;
	align-self: center;
	size: 100%;
	background-position-y: center;
	text-decoration: none;
	white-space: nowrap;
}

smoothly-app>smoothly-notifier>header>nav>ul {
	width: 100%;
}

smoothly-app>smoothly-notifier>header>nav>ul>div.nav-start-container {
	display: flex;
	align-items: center;
	height: 100%;
}

smoothly-app>smoothly-notifier>header>nav>ul>div.nav-end-container {
	display: flex;
	align-items: center;
	height: 100%;
	margin-left: auto;
	margin-right: 1rem;
}

smoothly-app>smoothly-notifier>header>nav>ul>[slot="nav-end"] {
	width: fit-content;
	align-self: center;
	height: fit-content;
	margin-left: 10rem;
}

smoothly-app>smoothly-notifier>header>nav>ul li a {
	display: flex;
	height: 2.3rem;
	text-decoration: none;
	align-items: center;
	align-self: center;
}

smoothly-app.smoothly-mobile-mode:not([menu-open])>smoothly-notifier>header>nav {
	display: none;
}

smoothly-app>smoothly-notifier>main>div {
	overflow-y: scroll;
	height: 100%;
}

/* Mobile mode */
smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav {
	width: fit-content;
	max-width: 100%;
	top: 100%;
	position: absolute;
	max-height: calc(100dvh - var(--header-height));
	overflow-y: scroll;
	right: 0;
	height: auto;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav,
smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul {
	flex-direction: column;
	background-color: rgba(var(--smoothly-color));
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul {
	padding: 1.5rem;
	box-sizing: border-box;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul li {
	margin-right: 0;
	width: 100%;
}
smoothly-app:not(.smoothly-mobile-mode)>smoothly-notifier>header>smoothly-burger {
	display: none;
}
smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>smoothly-burger {
	position: absolute;
	top: 0;
	right: 0;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul>[slot="nav-start"] {
	display: none;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul>div.nav-start-container,
smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul>div.nav-end-container {
	flex-direction: column;
	margin: 0;
	align-items: start;
	justify-content: center;
}

smoothly-app.smoothly-mobile-mode>smoothly-notifier>header>nav>ul>div.nav-start-container>*:last-child {
	margin-bottom: 1em;
}

